/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetPolymorphic } from './DatasetPolymorphic';
import {
  DatasetPolymorphicFromJSON,
  DatasetPolymorphicFromJSONTyped,
  DatasetPolymorphicToJSON,
} from './DatasetPolymorphic';

/**
 *
 * @export
 * @interface PaginatedDatasetPolymorphicList
 */
export interface PaginatedDatasetPolymorphicList {
  /**
   *
   * @type {number}
   * @memberof PaginatedDatasetPolymorphicList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetPolymorphicList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetPolymorphicList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DatasetPolymorphic>}
   * @memberof PaginatedDatasetPolymorphicList
   */
  results: Array<DatasetPolymorphic>;
}

/**
 * Check if a given object implements the PaginatedDatasetPolymorphicList interface.
 */
export function instanceOfPaginatedDatasetPolymorphicList(value: object): value is PaginatedDatasetPolymorphicList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedDatasetPolymorphicListFromJSON(json: any): PaginatedDatasetPolymorphicList {
  return PaginatedDatasetPolymorphicListFromJSONTyped(json, false);
}

export function PaginatedDatasetPolymorphicListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedDatasetPolymorphicList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(DatasetPolymorphicFromJSON),
  };
}

export function PaginatedDatasetPolymorphicListToJSON(value?: PaginatedDatasetPolymorphicList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(DatasetPolymorphicToJSON),
  };
}
